<template>
  <div class="menuOuterContainer" ref="menuOuterContainer">
    <div class="menContainer">
      <div
        class="menuHeader"
        :style="menuItems.length == 0 ? 'display:none' : 'display:flex'"
      >
        <div
          :class="'arrow-left' + (this.curActiveTab == 0 ? ' inactive' : '')"
          @click="moveToLeftHeader"
        ></div>
        <div class="headingScrollTextContainer">
          <div class="headingTextContainer" ref="headingTextContainer">
            <div
              v-for="(menuItem, index) in menuItems"
              @click="menuItemClicked(index)"
              :key="index"
              :class="menuItem.isActive ? 'menuItem active' : 'menuItem'"
            >
              {{ menuItem.headingTitle }}
            </div>
          </div>
        </div>
        <div
          :class="
            'arrow-right' +
            (this.curActiveTab == this.menuItems.length - 1 ? ' inactive' : '')
          "
          @click="moveToRightHeader"
        ></div>
      </div>
      <mobile-button-container :overlayContent="overlayContent"></mobile-button-container>

      <div class="menuContentContainer" ref="menuContentContainer">
        <component
          v-bind:is="menuItem.type"
          v-bind:data="menuItem.data"
          itemType="menuContentItem"
          ref="components"
          v-for="(menuItem, indexx) in menuItems"
          :key="indexx"
        ></component>
      </div>
      <div class="leftArrow"> 
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="isolation:isolate" viewBox="118.212 237.094 40.825 225.539" width="40.825pt" height="225.539pt"><path d=" M 157.537 461.133 L 119.712 349.863 L 157.537 238.594" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/></svg>          
          </div>
        <div class="rightArrow">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="isolation:isolate" viewBox="118.212 237.094 40.825 225.539" width="40.825pt" height="225.539pt"><path d=" M 157.537 461.133 L 119.712 349.863 L 157.537 238.594" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/></svg>          
        </div>
    </div>
  </div>
</template>

<script>
import welcomeContent from "./welcomeContent";
import videoHighlights from "./videoHighlights";
import topicSelection from "./topicSelection";
import speakerPresentation from "./speakerPresentation";
import pollContent from "./pollContent";
import transcriptContent from "./transcriptContent";
import biographiesContent from "./biograhpies-content";
import slideContent from "./slide-content";
import relatedContent from "./related-content";
import resourceContent from "./resource-content";
import isThisForMe from "./is-this-for-me";
import mobileButtonContainer from './mobile-button-container.vue'

export default {
  props: {
    overlayContent: {
      type: Object,
      required: true,
    },
  },
  components: {
    videoHighlights,
    topicSelection,
    speakerPresentation,
    pollContent,
    welcomeContent,
    transcriptContent,
    biographiesContent,
    slideContent,
    relatedContent,
    resourceContent,
    isThisForMe,
    mobileButtonContainer,

  },
  data() {
    return {
      curActiveTab: -1,
      menuItems: [],
      prvScrollPosition: 0,
      pauseScrollProcess: false,
      savedTabData:{
        lastSavedTabIndex:0,
        isCurrentTabAuto:false,
        tabSaveCount:0
      }
    };
  },
  mounted() {
    this.menuItems = this.overlayContent.menu.map((obj) => ({
      ...obj,
      isActive: false,
      isFirstLoad: true,
    }));
    this.menuItems.forEach((element) => {
      if (element.autoGenerateData == true) {
        var items = this.overlayContent.overlays.filter(
          (x) => x.parentItemType == element.childItemType
        );
        var data = [];
        items.forEach((element) => {
          data.push({
            title: element.name,
            startTime: element.in,
            endTime: element.out,
            navigateTime: element.navigateTime,
            instanceData: element.instanceData
          });
        });
        element.data = data;
      }
      if (element.type == "slide-content") element.data = this.overlayContent.slides;
    });
    this.$nextTick(function () {
      this.menuItemClicked(0);
      window.addEventListener("resize", () => {
        this.resize();
      });
    });
    this.$refs.menuContentContainer.addEventListener("scroll", this.scrolled);
  },
  methods: {
    scrollToItem(){
    },
    saveScrollState(menuItem){
      let menuItemIndex = null;
      for(var i=0;i<this.$refs.menuContentContainer.children.length;i++){
        if(this.$refs.menuContentContainer.children[i]==menuItem.$el){
          menuItemIndex=i;
          break;
        }
      }
      if(!this.savedTabData.isCurrentTabAuto)
        this.savedTabData.lastScroll = this.curActiveTab
      this.savedTabData.isCurrentTabAuto=true
      this.menuItemClicked(menuItemIndex,true)
      this.savedTabData.tabSaveCount++
      return this.savedTabData.tabSaveCount
    },
    cancelAutoScrollState(tabSaveCount){
      if(tabSaveCount==this.savedTabData.tabSaveCount){
        this.menuItemClicked(this.savedTabData.lastSavedTabIndex,true)
        this.savedTabData.isCurrentTabAuto=false
      }
    },
    runMethods(time) {
      for (var i = 0; i < this.$refs.components.length; i++) {
        if (this.$refs.components[i].process != null)
          this.$refs.components[i].process(time);
      }
    },
    moveToRightHeader() {
      if (this.curActiveTab != this.menuItems.length - 1)
        this.menuItemClicked(this.curActiveTab + 1, true);
    },
    moveToLeftHeader() {
      if (this.curActiveTab != 0)
        this.menuItemClicked(this.curActiveTab - 1, true);
    },
    scrolled() {
      if (this.pauseScrollProcess) {
        this.prvScrollPosition = this.$refs.menuContentContainer.scrollLeft;
        return;
      }
      var getCurrentIndex = 0;

      if (
        Math.abs(
          this.prvScrollPosition - this.$refs.menuContentContainer.scrollLeft
        ) <
        this.$refs.menuContentContainer.getBoundingClientRect().width / 10
      ) {
        return;
      }
      if (
        this.prvScrollPosition - this.$refs.menuContentContainer.scrollLeft >
        this.$refs.menuContentContainer.getBoundingClientRect().width / 2
      ) {
        //scrolling to left
        getCurrentIndex =
          this.$refs.menuContentContainer.scrollLeft %
          this.$refs.menuContentContainer.getBoundingClientRect().width;
        if (
          getCurrentIndex <
          0.2 * this.$refs.menuContentContainer.getBoundingClientRect().width
        ) {
          this.menuItemClicked(
            parseInt(
              this.$refs.menuContentContainer.scrollLeft /
                this.$refs.menuContentContainer.getBoundingClientRect().width
            ),
            false
          );
          this.prvScrollPosition = this.$refs.menuContentContainer.scrollLeft;
        }
      } else if (
        this.$refs.menuContentContainer.scrollLeft - this.prvScrollPosition >
        this.$refs.menuContentContainer.getBoundingClientRect().width / 2
      ) {
        getCurrentIndex =
          this.$refs.menuContentContainer.scrollLeft %
          this.$refs.menuContentContainer.getBoundingClientRect().width;
        if (
          getCurrentIndex >
          0.8 * this.$refs.menuContentContainer.getBoundingClientRect().width
        ) {
          this.menuItemClicked(
            parseInt(
              this.$refs.menuContentContainer.scrollLeft /
                this.$refs.menuContentContainer.getBoundingClientRect().width
            ) + 1,
            false
          );
          this.prvScrollPosition = this.$refs.menuContentContainer.scrollLeft;
        }
      }
    },
    menuItemClicked(index, changeScroll) {
      if (this.curActiveTab == index) return;
      if (this.curActiveTab != -1) {
        this.menuItems[this.curActiveTab].isActive = false;
        this.$nextTick(() => {
          if (this.curActiveTab < index)
            this.$refs.headingTextContainer.scroll(
              this.$refs.headingTextContainer.children[index].offsetLeft,
              0
            );
          else
            this.$refs.headingTextContainer.scroll(
              this.$refs.headingTextContainer.children[index].offsetLeft -
                this.$refs.headingTextContainer.children[
                  index
                ].getBoundingClientRect().width,
              0
            );
        });
      }
      var curHeight =
        this.$refs.menuContentContainer.children[
          index
        ].children[0].getBoundingClientRect().height + 15;
      this.$refs.menuContentContainer.style.height = curHeight + "px";
      if (window.innerWidth <= window.mobileWidth) {
        this.$nextTick(() => {
          var maxHeight =
            this.$refs.menuOuterContainer.getBoundingClientRect().height - 25;
          if (maxHeight > curHeight) {
            this.$refs.menuContentContainer.style.height = maxHeight + "px";
          } else {
            this.$refs.menuContentContainer.style.height = curHeight + "px";
          }
        });
      }
      if (changeScroll != false) {
        this.$nextTick(() => {
          this.pauseScrollProcess = true;
          setTimeout(() => {
            this.pauseScrollProcess = false;
          }, 1000);
          this.$refs.menuContentContainer.scroll(
            index *
              this.$refs.menuContentContainer.getBoundingClientRect().width,
            0
          );
        });
      }
      this.menuItems[index].isActive = true;
      if (this.menuItems[index].isFirstLoad) {
        this.menuItems[index].isFirstLoad = false;
        if (this.$refs.components[index].runFirstLoad)
          this.$refs.components[index].runFirstLoad();
      }
      this.curActiveTab = index;
    },
    resize() {
      if(!this.$refs.menuContentContainer)
        return
      this.$refs.menuContentContainer.style.height =
        this.$refs.menuContentContainer.children[
          this.curActiveTab
        ].children[0].getBoundingClientRect().height +
        15 +
        "px";
    },
  },
};
</script>
